import { motion } from "framer-motion";
import { Lock, Play } from "lucide-react";
import { upcomingLives } from "@/lib/schedule";
import { Draw, EASE, Ink, VIEW, datePart } from "./bits";

/** The next three lives as calendar cards: club classes (Patreon, members)
    and free YouTube lives, each linking to where it happens. */
export function LiveDates({ className = "", onMount = false }: { className?: string; onMount?: boolean }) {
  const lives = upcomingLives(3);
  const Stroke = onMount ? Draw : Ink;
  return <div className={`b2-dates b2-lives ${className}`}>
    <p className="b2-note">next lives!</p>
    <svg className="b2-arrow b2-arrow-down" viewBox="0 0 80 60" aria-hidden="true"><Stroke d="M10 6 C 20 30, 40 44, 66 48" delay={onMount ? 1.4 : 0.9} /><Stroke d="M52 36 L67 48 L52 58" delay={onMount ? 1.7 : 1.3} /></svg>
    <ul>{lives.map((l, i) => {
      const club = l.kind === "club";
      const show = { opacity: 1, y: 0, rotate: [-3, 3, -1.5][i] };
      return <motion.li key={l.start.toISOString()} className={`b2-live-${l.kind}`} initial={{ opacity: 0, y: 20 }}
        {...(onMount ? { animate: show } : { whileInView: show, viewport: VIEW })} transition={{ delay: (onMount ? 1.3 : 0.7) + i * 0.15, duration: 0.5, ease: EASE }}>
        <a href={l.url} target="_blank" rel="noreferrer"
          aria-label={`${datePart(l.start, { weekday: "long", month: "long", day: "numeric" })}, 7 PM Mountain: ${club ? "club class for members on Patreon" : "free live on YouTube"}`}>
          <small>{datePart(l.start, { weekday: "short" })}</small>
          <b>{datePart(l.start, { day: "numeric" })}</b>
          <span>{datePart(l.start, { month: "short" })} · 7 PM MT</span>
          <em>{club ? <><Lock size={11} aria-hidden="true" /> Club</> : <><Play size={11} fill="currentColor" aria-hidden="true" /> YouTube</>}</em>
        </a>
      </motion.li>;
    })}</ul>
    <p className="b2-lives-key">Free on YouTube most Tuesdays. Members get a two-night class in week two.</p>
  </div>;
}
